module.exports = __webpack_public_path__ + "static/media/notA.8c8d9a61.svg";